import { render, staticRenderFns } from "./partyInfo.vue?vue&type=template&id=9001909a&scoped=true&"
import script from "./partyInfo.vue?vue&type=script&lang=js&"
export * from "./partyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9001909a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9001909a')) {
      api.createRecord('9001909a', component.options)
    } else {
      api.reload('9001909a', component.options)
    }
    module.hot.accept("./partyInfo.vue?vue&type=template&id=9001909a&scoped=true&", function () {
      api.rerender('9001909a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/case/handing/partyInfo.vue"
export default component.exports